module.exports = __webpack_public_path__ + "static/media/prince-aha-stool-philippe-starck.c26520b6.jpg";